<template>
  <div style="position: relative;">
    <vue-p5 v-on="{ setup, mouseclicked, draw }"></vue-p5>  
  </div>
  
</template>
<script>
import VueP5 from 'vue-p5';
import { mapActions } from 'vuex';
export default {
  name : 'show-divider',
  props : {
    divider : {
      type : Object
    }
  },
  components : {
    VueP5
  },
  data(){
    return {
      sketch : null,
      point_radius : 10,
      each_side_margin : 10,
      points : {},
      mouse_pointer : {
        old : {x : null, y : null},
        new : {x : null, y : null}
      },
      current_divider : {
        start : null, end : null
      }, // For tracking line joining
      lines : [],
    }
  },
  methods : {
    ...mapActions(['updateCurrentAnswer']),
    mouseclicked() {
      if(!this.current_divider.start){
        
        // Started joining the points
        const mouse_over_point = this.checkMouseOverPoint()
        if(mouse_over_point['is_true']){
          const point_start_coord = Object.assign({}, mouse_over_point['circle'])
          // Check if a line already exists here,
          const line_exists_index = this.lines.findIndex(line => ((line.start.x == point_start_coord.x) && (line.start.y == point_start_coord.y)) || ((line.end.x == point_start_coord.x) && (line.end.y == point_start_coord.y)))
          if(line_exists_index == -1){
            // If a line doesnt exists
            this.$set(this.current_divider, 'start', point_start_coord)
          }else{
            // If a line already exists, then remove the existing line & call the setup method
            this.lines.splice(line_exists_index, 1)
            this.setup(this.sketch)
          }
        }
      }else if(this.current_divider.start && !this.current_divider.end){
        // Ending joining the points
        const mouse_over_point = this.checkMouseOverPoint()
        if(mouse_over_point['is_true']){
          const point_end_coord = Object.assign({}, mouse_over_point['circle'])
          // Checking if start and end points arent same
          if((this.current_divider.start.x != point_end_coord.x) || (this.current_divider.start.y != point_end_coord.y)){
            this.$set(this.current_divider, 'end', point_end_coord)
            // Now pushing this line
            this.lines.push(JSON.parse(JSON.stringify(this.current_divider)))
            //Emitting the data 
            this.emitData()
          }

          // Setting the current divider to null
          this.current_divider = {
            start : null, end : null
          }
        }else{
          this.current_divider = {
            start : null, end : null
          }
        }
        this.setup(this.sketch)
      }
    },
    drawCirclePoints(no_points, r, w, h){
      const angle_step = 360/no_points
      const start_angle = this.divider.circle.start_angle
      const sketch = this.sketch
      for(let angle_i = start_angle;angle_i<(360+start_angle);angle_i+=angle_step){
        const angle_i_rad = angle_i * (Math.PI/180);
        const current_x_circle = parseInt(w/2 + this.each_side_margin + (r*Math.cos(angle_i_rad)))
        const current_y_circle = parseInt(h/2 + this.each_side_margin + (r*Math.sin(angle_i_rad)))
        sketch.circle(current_x_circle, current_y_circle, this.point_radius)
        const coord_key = `${current_x_circle}-${current_y_circle}`
        this.points[coord_key] = true
      }
    },
    drawRectanglePoints(type, polygon_width, polygon_height, initial_x, initial_y){
      const sketch = this.sketch
      const segment_width = polygon_width/(this.divider.polygon.no_points_x_axis - 1)
      const segment_height = polygon_height/(this.divider.polygon.no_points_y_axis - 1)
      let current_x_circle = initial_x
      let current_y_circle = initial_y
      // Plotting for top and bottom
      if(['TOP', 'BOTTOM'].includes(type)){
        for(let i = 0;i<this.divider.polygon.no_points_x_axis;i++){
          sketch.circle(current_x_circle, current_y_circle, this.point_radius)
          const coord_key = `${current_x_circle}-${current_y_circle}`
          this.points[coord_key] = true
          current_x_circle += segment_width
        }

      }
      // Plotting for left and right
      if(['LEFT', 'RIGHT'].includes(type)){
        for(let i = 0;i<this.divider.polygon.no_points_y_axis;i++){
          sketch.circle(current_x_circle, current_y_circle, this.point_radius)
          const coord_key = `${current_x_circle}-${current_y_circle}`
          this.points[coord_key] = true
          current_y_circle += segment_height
        }
      }
    },
    checkMouseOverPoint(){
      let is_true = false
      let circle = null
      const sketch = this.sketch
      for(let point_key in this.points){
        let [point_x, point_y] = point_key.split("-").map(coord => parseInt(coord))
        let mouseX = sketch.mouseX
        let mouseY = sketch.mouseY
        // If current mouse coordinate lies on the point
        if((mouseX >= point_x-this.point_radius) && (mouseX <= point_x+this.point_radius) && (mouseY >= point_y-this.point_radius) && (mouseY <= point_y+this.point_radius)){
          is_true = true
          circle = {x : point_x, y : point_y}
          break
        }
      }
      return {is_true, circle}
    },
    draw(sketch){
      sketch.cursor(sketch.ARROW)
      // Checking if current mouse coordinate on any of the circle
      if(this.checkMouseOverPoint()['is_true']){
        sketch.cursor('pointer')
      }

      // Updating the current mouse location. We will also update old at last
      this.$set(this.mouse_pointer, 'new', {
        x : sketch.mouseX, y : sketch.mouseY
      })

      // If joining the points, draw a line
      if(this.isJoining){
        // Removing previously created line if new and old mouse points doesnt match
        if((this.mouse_pointer.new.x != this.mouse_pointer.old.x) || (this.mouse_pointer.new.y != this.mouse_pointer.old.y)){
          this.setup(sketch)
        }
        // Drawing the line
        sketch.line(this.current_divider.start.x, this.current_divider.start.y, sketch.mouseX, sketch.mouseY)
      }

      // Updating the old mouse pointer location
      this.$set(this.mouse_pointer, 'old', {
        x : sketch.mouseX, y : sketch.mouseY
      })
    },
    setup(sketch){
      if(sketch){
        // let _vm = this
        this.sketch = sketch

        // Removing the whole sketch first
        sketch.clear()
        
        let canvas_width = this.divider.width
        let canvas_height = (this.divider.type == 'RECTANGLE') ? this.divider.height : canvas_width

        // Drawing the canvas
        sketch.createCanvas(canvas_width,canvas_height)

        const each_side_margin = this.each_side_margin
        // Drawing the shape
        sketch.fill(sketch.color(this.divider.bg_color))

        const polygon_width = canvas_width - (2*each_side_margin)
        const polygon_height = canvas_height - (2*each_side_margin)
        
        
        // Drawing the points 
        if(this.divider.type == 'RECTANGLE'){
          sketch.rect(each_side_margin,each_side_margin,polygon_width,polygon_height)
          // Drawing x points
          this.drawRectanglePoints('TOP', polygon_width, polygon_height, each_side_margin, each_side_margin)
          this.drawRectanglePoints('BOTTOM', polygon_width, polygon_height, each_side_margin, each_side_margin+polygon_height)
          // Drawing y points
          this.drawRectanglePoints('LEFT', polygon_width, polygon_height, each_side_margin, each_side_margin)
          this.drawRectanglePoints('RIGHT', polygon_width, polygon_height, each_side_margin+polygon_width, each_side_margin)
          
        }else if(this.divider.type == 'CIRCLE'){
          sketch.circle(canvas_width/2, canvas_height/2, polygon_width)
          this.drawCirclePoints(this.divider.circle.no_points, polygon_width/2, polygon_width, polygon_height)
        }

        // Drawing the joined lines if any
        sketch.strokeWeight(3)
        sketch.stroke(this.divider.stroke_color)
        for(let line of this.lines){
          sketch.line(line.start.x, line.start.y, line.end.x, line.end.y)
        }

      }
    },
    emitData(){
      this.updateCurrentAnswer({
        key : "divider", 
        value : this.lines
      })
    }
  },
  computed : {
    isJoining(){
      return this.current_divider.start && !this.current_divider.end
    }
  },
  render(h) {
    return h(VueP5, {on: this});
  },
  watch : {
    divider : {
      handler(){
        this.setup(this.sketch)
      },
      deep : true
    },
  },
  created(){
  }
}
</script>